// Careful, do not mistake with utils/localStorage
export var getFromSessionStorage = function (key) { return function () {
    try {
        var value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    }
    catch (error) {
        return null;
    }
}; };
export var setToSessionStorage = function (key) { return function (value) {
    sessionStorage.setItem(key, JSON.stringify(value));
}; };
export var removeFromSessionStorage = function (key) {
    sessionStorage.removeItem(key);
};
